<fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight]  current="Customer Service Agreement"></fury-breadcrumbs>
    </fury-page-layout-header>
   
    <fury-page-layout-content [@fadeInUp]>
      <div class="block_area">
        <fury-common-kpi-blocks [mainPage]="'agreements'" [data]="kpiData"></fury-common-kpi-blocks>
      </div>
      <fury-list name={{filterValue}} [columns]="columns" (filterChange)="onFilterChange($event)">
        <div style="position: relative;" class="filter">
            <button class="filter fury-column-filter" type="button" mat-icon-button (click)="showFilter()">
              <img src="../../../assets/img/filter.png" alt="filter"/>
            </button>
            <div class="filteringprt" *ngIf="isShowFilter">
              <form [formGroup]="filterForm">
              <h3 style="margin: 0;">Filter</h3>
              <mat-form-field appearance="outline">
                <mat-label>Search By</mat-label>
                <mat-select formControlName="searchBy">
                  <mat-option *ngFor="let item of serchByValue" [value]="item?.value">{{item.title}}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Search Type</mat-label>
                <mat-select formControlName="searchType">
                  <mat-option *ngFor="let item of commonService?.searchTypeValue" [value]="item?.value">{{item.title}}</mat-option>
                </mat-select>
              </mat-form-field>
              <div class="btnprt">
                <button mat-button class="can-button" (click)="showFilter()">Cancel</button>
                <button mat-button class="sub-button" (click)="filterChange()">Search</button>
              </div>
            </form>
            </div>
          </div>
          <div class="table_container">
            <table [dataSource]="dataSource" mat-table>
              <!-- actions Column -->
              <ng-container matColumnDef="actions" stickyEnd>
                  <th *matHeaderCellDef class="actions-cell" mat-header-cell>Actions</th>
                  <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                      <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                          (click)="$event.stopPropagation()">
                          <mat-icon>more_horiz</mat-icon>
                      </button>
                      <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                          <button mat-menu-item (click)="redirectViewAgreementPage(row)">
                              <span>View Agreement</span>
                          </button>
                          <button mat-menu-item (click)="getServiceAgreementPdf(row)">
                            <span>Download Agreement</span>
                        </button>
                      </mat-menu>
                  </td>
              </ng-container>
              <ng-container matColumnDef="agent">
                  <th mat-header-cell *matHeaderCellDef>Created By</th>
                  <td mat-cell *matCellDef="let element">
                    {{ commonService.getFullName(element?.agentDetail?.firstName, element?.agentDetail?.lastName) }}
                  </td>
                </ng-container>
          
                <!-- serviceAgreementNumber Column -->
                <ng-container matColumnDef="serviceAgreementNumber">
                  <th mat-header-cell *matHeaderCellDef>Policy No.</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.agreementNumber }}
                  </td>
                </ng-container>
          
                <!-- agreementStatus Column -->
                <ng-container matColumnDef="agreementStatus">
                  <th mat-header-cell *matHeaderCellDef>Status</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.status }}
                  </td>
                </ng-container>
          
                <!-- user Column -->
                <ng-container matColumnDef="user">
                  <th mat-header-cell *matHeaderCellDef>Full Name</th>
                  <td mat-cell *matCellDef="let element">
                    {{ commonService.getFullName(element?.firstName, element?.lastName) }}
                  </td>
                </ng-container>
          
                <!-- planType Column -->
                <ng-container matColumnDef="planType">
                  <th mat-header-cell *matHeaderCellDef>Plan Type</th>
                  <td mat-cell *matCellDef="let element">{{ element?.orderPlanDetail?.orderMainPlan }}</td>
                </ng-container>
          
                <!-- propertyType Column -->
                <ng-container matColumnDef="propertyType">
                  <th mat-header-cell *matHeaderCellDef>Property Type</th>
                  <td mat-cell *matCellDef="let element">{{ element?.orderPlanDetail?.orderPropertyTypeName }}</td>
                </ng-container>
          
                <!-- propertySize Column -->
                <ng-container matColumnDef="propertySize">
                  <th mat-header-cell *matHeaderCellDef>Property Size</th>
                  <td mat-cell *matCellDef="let element">{{ element?.orderPlanDetail?.orderPropertySizeName }}</td>
                </ng-container>
          
                <!-- coverageTerm Column -->
                <ng-container matColumnDef="coverageTerm">
                  <th mat-header-cell *matHeaderCellDef>Term</th>
                  <td mat-cell *matCellDef="let element" > {{ element.agreementExpireDate ===  null ? element.agreementEffectiveDate + ' - Ongoing' : element.agreementEffectiveDate + ' - '+ element.agreementExpireDate }}</td>
                </ng-container>
          
                <!-- agreementPrice Column -->
                <ng-container matColumnDef="agreementPrice">
                  <th mat-header-cell *matHeaderCellDef>Price</th>
                  <td mat-cell *matCellDef="let element">
                    {{ formatCurrency(element?.subTotalCost) }}
                  </td>
                </ng-container>
          
                <!-- netReceived Column -->
                <ng-container matColumnDef="netReceived">
                  <th mat-header-cell *matHeaderCellDef>Paid</th>
                  <td mat-cell *matCellDef="let element">
                    {{ formatCurrency(element?.downPaymentAmount) }}
                  </td>
                </ng-container>
          
                <!-- balance Column -->
                <ng-container matColumnDef="balance">
                  <th mat-header-cell *matHeaderCellDef>Balance</th>
                  <td mat-cell *matCellDef="let element">
                    {{ formatCurrency(element?.subTotalCost - element?.downPaymentAmount) }}
                  </td>
                </ng-container>
          
                <!-- createdOn Column -->
                <ng-container matColumnDef="createdOn">
                  <th mat-header-cell *matHeaderCellDef>Creation Date</th>
                  <td mat-cell *matCellDef="let element">{{ element?.agreementPurchaseDate }}</td>
                </ng-container>
          
                <!-- waitingPeriod Column -->
                <ng-container matColumnDef="waitingPeriod">
                  <th mat-header-cell *matHeaderCellDef>Waiting Period</th>
                  <td mat-cell *matCellDef="let element">
                    {{ getWaitingPeriod(element?.waitingPeriod) }}
                  </td>
                </ng-container>
          
                <!-- agreementEffectiveDate Column -->
                <ng-container matColumnDef="agreementEffectiveDate">
                  <th mat-header-cell *matHeaderCellDef>Effective Date</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.agreementEffectiveDate }}
                  </td>
                </ng-container>
          
                <!-- copaymentFee Column -->
                <ng-container matColumnDef="copaymentFee">
                  <th mat-header-cell *matHeaderCellDef>Copay</th>
                  <td mat-cell *matCellDef="let element">
                    {{ formatCurrency(element?.copayFee) }}
                  </td>
                </ng-container>
          
                <!-- streetAddress Column -->
                <ng-container matColumnDef="streetAddress">
                  <th mat-header-cell *matHeaderCellDef>Address</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.billingAddress?.streetAddress }}
                  </td>
                </ng-container>
          
                <!-- City Column -->
                <ng-container matColumnDef="city">
                  <th mat-header-cell *matHeaderCellDef>City</th>
                  <td mat-cell *matCellDef="let element">{{ element?.billingAddress?.city }}</td>
                </ng-container>
          
                <!-- State Column -->
                <ng-container matColumnDef="state">
                  <th mat-header-cell *matHeaderCellDef>State</th>
                  <td mat-cell *matCellDef="let element">{{ element?.billingAddress?.state }}</td>
                </ng-container>
          
                <!--  Zip Code Column -->
                <ng-container matColumnDef="zip">
                  <th mat-header-cell *matHeaderCellDef>Zip Code</th>
                  <td mat-cell *matCellDef="let element">{{ element?.billingAddress?.zip }}</td>
                </ng-container>
          
                <!--  mobileNumber Column -->
                <ng-container matColumnDef="mobileNumber">
                  <th mat-header-cell *matHeaderCellDef>Phone</th>
                  <td mat-cell *matCellDef="let element">{{ element?.phoneNumber | mask: '(000) 000-0000' }}</td>
                </ng-container>
          
                <!--  emailAddress Column -->
                <ng-container matColumnDef="emailAddress">
                  <th mat-header-cell *matHeaderCellDef>Email</th>
                  <td mat-cell *matCellDef="let element">{{ element?.emailAddress }}</td>
                </ng-container>
          
                <!--  hardCopy Column -->
                <ng-container matColumnDef="hardCopy">
                  <th mat-header-cell *matHeaderCellDef>Hard Copy</th>
                  <td mat-cell *matCellDef="let element">{{ element?.hardCopy }}</td>
                </ng-container>
          
                <!--  mailingTracking Column -->
                <ng-container matColumnDef="mailingTracking">
                  <th mat-header-cell *matHeaderCellDef>Tracking</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.mailingTracking }}
                  </td>
                </ng-container>
          
                <!--  cancellationDate Column -->
                <ng-container matColumnDef="cancellationDate">
                  <th mat-header-cell *matHeaderCellDef>Cancelled On</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.cancellationDate }}
                  </td>
                </ng-container>
          
                <!--  reasonForCancellation Column -->
                <ng-container matColumnDef="reasonForCancellation">
                  <th mat-header-cell *matHeaderCellDef>Cancellation Reason</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.reasonForCancellation }}
                  </td>
                </ng-container>
          
                <!--  payments Column -->
                <ng-container matColumnDef="payments">
                  <th mat-header-cell *matHeaderCellDef># of Payments</th>
                  <td mat-cell *matCellDef="let element">{{ element?.payments }}</td>
                </ng-container>
          
                <!--  surcharge Column -->
                <ng-container matColumnDef="surcharge">
                  <th mat-header-cell *matHeaderCellDef>Surcharge</th>
                  <td mat-cell *matCellDef="let element">
                    {{ formatCurrency(element?.surchargeAmount) }}
                  </td>
                </ng-container>
          
                <!--  leadSource Column -->
                <ng-container matColumnDef="leadSource">
                  <th mat-header-cell *matHeaderCellDef>Lead Source</th>
                  <td mat-cell *matCellDef="let element">{{ element?.leadSource }}</td>
                </ng-container>
          
                <ng-container matColumnDef="claimAction" stickyEnd>
                  <th mat-header-cell *matHeaderCellDef>Action</th>
                  <td mat-cell *matCellDef="let element"><span style="cursor: pointer;" (click)="handleAgreement(element)"><mat-icon>open_in_new</mat-icon></span></td>
                </ng-container>
              
              <tr *matHeaderRowDef="visibleColumns; sticky: true" mat-header-row></tr>
              <tr *matRowDef="let row; columns: visibleColumns"
                  class="clickable route-animations-elements" mat-row>
              </tr>
          </table>
          </div>
        
        <div *ngIf="itemList?.length === 0" style="padding: 10px 0; text-align:center;">
          No User found.
      </div>
        <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
            showFirstLastButtons
            [selectConfig] = "selectConfig"
            [ngClass]="{'mat-pegig': pageSize === 9999}"
            aria-label="Select page of periodic elements">
        </mat-paginator>
       
  
      </fury-list>
  
    </fury-page-layout-content>
</fury-page-layout>